module.exports = __webpack_public_path__ + "img/cy-nc.c7c7ae0a.svg";